module.exports = __webpack_public_path__ + "static/media/header.e3381d2d.png";